import React, { useState, useCallback } from 'react';
import { Tooltip, Close } from './styled';

const TooltipContainer = ({ text }) => {
  const [show, setShow] = useState(true);
  const closeHandler = useCallback(() => setShow(false), []);

  return show && <Tooltip>
    {text}
    <Close onClick={closeHandler}/>
  </Tooltip>;
};

export default TooltipContainer;
